module.exports = __webpack_public_path__ + "img/upload-outline.546c5150.svg";